import * as S from './style'

export const Loading = () => {
  return (
    <S.Container>
      <S.Spinner></S.Spinner>
    </S.Container>
  )
}
